import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  FormLabel,
  Input,
  InputGroup,
  InputRightElement,
  FormHelperText,
  IconButton,
} from '@chakra-ui/react';
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';

export default function LabelInput({ label, name, type, validationRules, ...rest }) {
  const {
    register,
    formState: { errors, isSubmitting },
  } = useFormContext();

  const hasError = name in errors;
  const isPassword = type === 'password';

  const [show, setShow] = useState(false);
  const toggleShow = () => setShow((prev) => !prev);

  return (
    <div className="mb-3">
      <FormLabel htmlFor={name}>{label}</FormLabel>

      {isPassword ? (
        <InputGroup>
          <Input
            {...register(name, validationRules)}
            id={name}
            type={show ? 'text' : 'password'}
            isDisabled={isSubmitting}
            className="form-control"
            {...rest}
          />
          <InputRightElement height="100%">
            <IconButton
              variant="ghost"
              size="sm"
              marginRight={7}
              onClick={toggleShow}
              icon={show ? <ViewOffIcon /> : <ViewIcon />}
              aria-label="Toggle wachtwoord tonen"
            />
          </InputRightElement>
        </InputGroup>
      ) : (
        <Input
          {...register(name, validationRules)}
          id={name}
          type={type}
          isDisabled={isSubmitting}
          className="form-control"
          {...rest}
        />
      )}

      {hasError && (
        <FormHelperText color="red.500" data-cy="label_input_error">
          {errors[name].message}
        </FormHelperText>
      )}
    </div>
  );
}
